import { Component } from '@angular/core';
import { EstimateService } from '../../../estimate.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'dialogue',
  templateUrl: './estimate-dialogue.component.html',
  styleUrls: ['./estimate-dialogue.component.scss']
})
export class DialogueComponent {

  textControl: FormControl = new FormControl('');

  constructor(
    private progress: EstimateService
  ) { }

  onSubmit() {
    this.progress.dialogueInput.next(this.textControl.value)
  }
}
